import {IAccVoucherVm} from "../../model/respone/category/IAccVoucher";
import {apiClient} from "../apiClient";

export const VOUCHER_ENDPOINT = "voucher";
export const voucherApi = {
    SelectAllVm: () => apiClient.get(`${VOUCHER_ENDPOINT}`),
    Insert: (payload: IAccVoucherVm) =>
        apiClient.post(`${VOUCHER_ENDPOINT}`, payload),
    Update: (payload: IAccVoucherVm) =>
        apiClient.put(`${VOUCHER_ENDPOINT}`, payload),
    Delete: (id: number) => apiClient.delete(`${VOUCHER_ENDPOINT}/${id}`),
    DeleteMany: (ids: number[]) =>
        apiClient.post(`${VOUCHER_ENDPOINT}/delete-many`, ids),
    CheckChange: (payload: IAccVoucherVm) =>
        apiClient.post(`${VOUCHER_ENDPOINT}/check-change`, payload),
};
